import "./style.less";

export default function TablePeriod(moment) {
    return {
        restrict: "E",
        scope: {
            weeks: "<",
            status: "<",
            period: "<",
            callback: "&",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            $scope.name = $scope.weeks == 1 ? "Uge" : "Uger";

            $scope.getAriaLabel = (period) => {
                const label = `${period._resource.name} er tilgængelig i ${
                    $scope.weeks
                } ${$scope.name} mellem ${getTime(period)}`;

                return label;
            };

            const getTime = (period) => {
                return `klokken ${moment(period.start, "hh:mm:ss").hours()} ${
                    moment(period.start, "hh:mm:ss").minutes() > 0
                        ? moment(period.start, "hh:mm:ss").minutes()
                        : ""
                } til ${moment(period.end, "hh:mm:ss").hours()} ${
                    moment(period.end, "hh:mm:ss").minutes() > 0
                        ? moment(period.end, "hh:mm:ss").minutes()
                        : ""
                }`;
            };
        },
    };
}
